import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import store from './store';
import { AuthProvider } from './contexts/authContext';
// `react-sortable-tree/style.css` is intentionally omitted; the sortable tree
// is stubbed in src/compat/sortableTreeStub.tsx pending a modern replacement.
import './custom.css';

if (import.meta.env.MODE !== 'development') {
  // eslint-disable-next-line no-console
  console.log(
    `Build ${import.meta.env.VITE_BUILD_NUMBER ?? '?'} (${import.meta.env.VITE_COMMIT_HASH ?? '?'})`
  );
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <HelmetProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
